/* eslint-disable max-len */
/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	examData          : [],
	networkExamData   : [],
	markingSystemData : { publish: [], unPublish: [] },
	questionData      : [],
	questionBankData  : { publish: [], unPublish: [] },
	templateData      : { publish: [], unPublish: [] },
	certificateData   : { publish: [], unPublish: [] }
};

export const certificationslice = createSlice({
	name     : 'certification',
	initialState,
	reducers : {
		getExamRedux : (state, action) =>
		{
			state.examData = action.payload;
		},
		setNetworkExamRedux : (state, action) =>
		{
			state.networkExamData = action.payload;
		},
		getMarkingRedux : (state, action) =>
		{
			state.markingSystemData = { ...state.markingSystemData, ...action.payload };
		},
		getQuestionRedux : (state, action) =>
		{
			state.questionData = action.payload;
		},
		getQuestionBankRedux : (state, action) =>
		{
			state.questionBankData = { ...state.questionBankData, ...action.payload };
		},
		getTemplateRedux : (state, action) =>
		{
			state.templateData = { ...state.templateData, ...action.payload };
		},
		getCertificateRedux : (state, action) =>
		{
			state.certificateData = { ...state.certificateData, ...action.payload };
		}
	}
});

export const { getExamRedux, setNetworkExamRedux, getMarkingRedux, getQuestionRedux, getQuestionBankRedux, getTemplateRedux, getCertificateRedux } = certificationslice.actions;
export default certificationslice.reducer;